import {useEffect, useMemo} from 'react'
import HashListener from '../common/components/HashListener.js'

import {useSelector} from '../store.js'
import {locationSelector} from '../redux/selectors/ui/location.js'
import datadogRum from '../common/analytics/datadogRum.js'

export default function AppHashListener() {
  const {pathComponents} = useSelector(locationSelector)

  const viewName = useMemo(
    () => '#/' + pathComponents.join('/'),
    [pathComponents],
  )

  useEffect(() => {
    if (viewName === '#/') {
      return
    }

    datadogRum.startView({name: viewName})
  }, [viewName])

  return <HashListener />
}
